module.exports = __webpack_public_path__ + "static/media/group.f48700e1.svg";